import { render } from "./StandardItem.vue?vue&type=template&id=582e521f"
import script from "./StandardItem.vue?vue&type=script&lang=js"
export * from "./StandardItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__